import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevron = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M11.2946 8.99984L6.70461 13.5898C6.31461 13.9798 6.31461 14.6098 6.70461 14.9998C7.09461 15.3898 7.72461 15.3898 8.11461 14.9998L12.0046 11.1198L15.8846 14.9998C16.2746 15.3898 16.9046 15.3898 17.2946 14.9998C17.6846 14.6098 17.6846 13.9798 17.2946 13.5898L12.7046 8.99984C12.3246 8.60984 11.6846 8.60984 11.2946 8.99984Z",
		fill: "#151D20"
	})]
});
const ForwardRef = forwardRef(SvgChevron);
export { ForwardRef as ReactComponent };
